import script from "./AnswerRates.vue?vue&type=script&setup=true&lang=js"
export * from "./AnswerRates.vue?vue&type=script&setup=true&lang=js"

import "./AnswerRates.vue?vue&type=style&index=0&id=5674f529&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5674f529"]])

export default __exports__